import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { FullMatchFragment } from '../../generated/graphql';
import { paths } from '../../paths';

import { MatchScore } from './Stats/MatchScore';
import { MatchScorers } from './Stats/MatchScorers';
import { MatchCards } from './Stats/MatchCards';
import { SetLocation } from './SetLocation';
import { PickSquad } from './PickSquad';
import { PickKit } from './PickKit';
import { EditMatch } from './EditMatch';
import { MatchAssists } from './Stats/MatchAssists';
import { MatchSettings } from './MatchSettings';
import { CreateMatchReport } from './CreateMatchReport';

interface Props {
  match: FullMatchFragment;
}

export const MatchSettingsRouter: React.FC<Props> = ({ match }) => {
  return (
    <Switch>
      <Route
        path={paths.match.settings.location()}
        render={() => <SetLocation match={match} />}
        exact={true}
      />
      <Route
        render={() => <MatchSettings match={match} />}
        path={paths.match.settings.home()}
        exact={true}
      />
      <Route
        render={(routeProps) => (
          <EditMatch match={match} history={routeProps.history} />
        )}
        exact={true}
        path={paths.match.settings.details()}
      />
      <Route
        render={() => <PickSquad match={match} />}
        path={paths.match.settings.squad()}
        exact={true}
      />

      <Route
        render={() => <PickKit match={match} />}
        path={paths.match.settings.kit()}
        exact={true}
      />

      <Route
        render={() => <MatchScore match={match} />}
        path={paths.match.settings.score()}
        exact={true}
      />
      <Route
        render={() => <MatchScorers match={match} />}
        path={paths.match.settings.scorers()}
        exact={true}
      />
      <Route
        render={() => <MatchCards match={match} />}
        path={paths.match.settings.cards()}
        exact={true}
      />
      <Route
        render={() => <MatchAssists match={match} />}
        path={paths.match.settings.assists()}
        exact={true}
      />

      <Route
        render={() => <CreateMatchReport match={match} />}
        path={paths.match.settings.matchReport()}
        exact={true}
      />

      <Route render={() => <Redirect to={paths.match.home(match.id)} />} />
    </Switch>
  );
};
